import { render, staticRenderFns } from "./TemplateMapDetail.vue?vue&type=template&id=c4d0e56a"
import script from "./TemplateMapDetail.vue?vue&type=script&lang=js"
export * from "./TemplateMapDetail.vue?vue&type=script&lang=js"
import style0 from "./TemplateMapDetail.vue?vue&type=style&index=0&id=c4d0e56a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d0e56a')) {
      api.createRecord('c4d0e56a', component.options)
    } else {
      api.reload('c4d0e56a', component.options)
    }
    module.hot.accept("./TemplateMapDetail.vue?vue&type=template&id=c4d0e56a", function () {
      api.rerender('c4d0e56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/farm/components/TemplateMapDetail.vue"
export default component.exports